import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class CustomUrlSerializer extends DefaultUrlSerializer {
  parse(url: string): UrlTree {
    // Normalize multiple consecutive slashes to single slash
    url = url.replace(/\/\/+/g, '/');
    return super.parse(url);
  }
}
